<div class="panel-container" *ngIf="!loading && currentNode?.children?.length">
  <div class="panel-header">
    <div class="node-title" *ngIf="currentNode?.parent">
        <button (click)="navigateBack(currentNode.parent)" class="btn btn-small icon-ui-left-triangle-arrow"></button>
        <span class="node-info-name">{{ currentNode?.data?.title || currentNode?.data?.name }}</span>
    </div>
  <div class="tree-container">
    <div class="tree-node" *ngFor="let child of currentNode?.children" [hidden]="groups">
        <div class="node-content" *ngIf="child.data.nodeType !== NodeType.Document" (mouseenter)="onMouseEnter(child)" (mouseleave)="onMouseLeave()">
            <button class="node-button" (click)="navigateToNode(child,assets)"
                    [disabled]="!child?.data?.enabled || child?.loading" [attr.title]="child?.data?.description">
              <span class="display-text" [innerText]="child?.name"></span>
              <span *ngIf="child?.loading">...</span>
            </button>
        </div>
        <div class="document" *ngIf="child.data.nodeType === NodeType.Document">
          <span class="file-name">{{ child.data.name }}</span>
          <div class="options-container">
            <a class="open icon-ui-maximize option" title="open in new tab" [href]="child.data.record.url" target="_blank" rel="noopener noreferrer"></a>
            <a class="download icon-ui-download option" title="download" [href]="child.data.record.url + '&download=1'" download></a>
          </div>
        </div>
    </div>
    <div class="group" *ngFor="let group of groups">
        <button class="accordion" *ngIf="group[1].length > 0" (click)="toggleAccordion($event)">
          {{ group[0] }}
        </button>
        <div class="panel">
          <div class="tree-node" *ngFor="let child of group[1]">
            <div class="node-content" *ngIf="child.data.nodeType !== NodeType.Document" (mouseenter)="onMouseEnter(child)" (mouseleave)="onMouseLeave()">
              <button class="node-button" (click)="navigateToNode(child,assets)"
                  [disabled]="!child?.data?.enabled || child?.loading"
                  [attr.title]="child?.data?.description">
                <span class="display-text" [innerText]="child?.name"></span>
                <span *ngIf="child?.loading"> ...</span>
              </button>
              <div #dropdown class="dropdown">
                <button class="btn btn-transparent dropdown-btn" tabindex="0" (click)="toggleDropdown($event)" aria-haspopup="true" aria-expanded="false">
                  <span class="icon-ui-handle-horizontal icon-ui-flush"></span>
                </button>
                <nav class="dropdown-content" role="menu">
                  <div *ngIf="child?.data.link">
                    <a href="#" title="Open Related App" [href]="child?.data.link" target="_blank" (click)="onLinkOpen()">
                      Open App
                    </a>
                  </div>
                  <div *ngIf="child.data?.graphic">
                    <a href="#" title="Street View" (click)="onStreetViewOpen(child)">Street View</a>
                    <a href="#" title="Video Log" (click)="onVideoLogOpen(child)">Video Log</a>
                  </div>
                </nav>
              </div>
            </div>
            <div class="document" *ngIf="child.data.nodeType === NodeType.Document">
              <span class="file-name">{{ child.data.name }}</span>
              <div class="options-container">
                <a class="open icon-ui-maximize option" title="open in new tab" [href]="child.data.record.url" target="_blank" rel="noopener noreferrer"></a>
                <a class="download icon-ui-download option" title="download" [href]="child.data.record.url + '&download=1'" download></a>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>
